import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import { StyledAspectRatioWrapper } from "./styled";
import { calcAspectRatio } from "../ImageEditor/utils/calcAspectRatio";
import { useScreenWidth } from "oolib";



const AspectRatioShell = ({
  id,
  invert,
  aspectRatio,
  children,
  stretchToFullHeight,
  containerShape,
  disableImageBorder,
  onShellPrepared
}) => {
  const wrapperRef = useRef(null);

  const [dimensions, setDimensions] = useState({ width: 'auto', height: 'auto' });

  const updateDimensions = () => {
    if (wrapperRef.current) {
      if (stretchToFullHeight) {
        const newWidth = wrapperRef.current.clientHeight * calcAspectRatio(aspectRatio);
        setDimensions(prev => ({ ...prev, width: `${newWidth}px` }));
      } else {
        const newHeight = wrapperRef.current.offsetWidth / calcAspectRatio(aspectRatio);
        setDimensions(prev => ({ ...prev, height: `${newHeight}px` }));
      }
    }
  };


  useLayoutEffect(() => {
    updateDimensions();
    const resizeObserver = new ResizeObserver(updateDimensions);
    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [aspectRatio, stretchToFullHeight]);


  useEffect(() => {
    
    if(dimensions.width !== 'auto' || dimensions.height !== 'auto'){
      //means the shell is ready with the proper dimensions
      onShellPrepared && onShellPrepared() //we use this fn. in imageEditor to trigger off the decision on toolbar style
    }
  },[dimensions, onShellPrepared])

  useScreenWidth(updateDimensions);

  return (
    <StyledAspectRatioWrapper
      id='StyledAspectRatioWrapper'
      ref={wrapperRef}
      width={stretchToFullHeight ? dimensions.width : "100%"}
      height={stretchToFullHeight ? "100%" : dimensions.height}
      containerShape={containerShape}
      invert={invert}
      disableImageBorder={disableImageBorder}
    >
      {children}
    </StyledAspectRatioWrapper>
  );
};

export default AspectRatioShell;
